/* The group class Cancel pop-up: who cancelled, and when the teacher asked (pure). */
import {
  GROUP_CANCEL_ADMIN,
  GROUP_CANCEL_TEACHER,
  group_cancel_flags_sent,
  group_cancel_options,
  teacher_cancel_check
} from '../sessions/single_session_details/session_change_rules';
import { requested_at_to_iso } from '../../util_components/teacher_cancel_bucket_picker/bucket_rules';

const IST = 'Asia/Kolkata';

// Classes starting on/after 1 Nov 2026 00:00 IST need the teacher's request time (Kuldeep, A-52).
export const TEACHER_TIME_FROM_MS = Date.parse('2026-10-31T18:30:00Z');

// A workshop class has no student side to blame for its own cancel: Admin or Teacher, like a group class.
export const cancel_who_options = (session_type) => {
  if (!asks_who_cancelled(session_type)) return [];
  return session_type === 'WORKSHOP_SESSION'
    ? [GROUP_CANCEL_ADMIN, GROUP_CANCEL_TEACHER]
    : group_cancel_options(session_type);
};

// apis cancels a friends class as admin and ignores who/when (cancel_friends_session), and the
// engine never prices it, so the pop-up does not ask.
export const YOGA_WITH_FRIENDS_SESSION = 'YOGA_WITH_FRIENDS_SESSION';
export const asks_who_cancelled = (session_type) => session_type !== YOGA_WITH_FRIENDS_SESSION;

export const needs_teacher_time = (cancel_pick, epoch_start_time) =>
  cancel_pick === GROUP_CANCEL_TEACHER && Number(epoch_start_time) >= TEACHER_TIME_FROM_MS;

// The first problem to show ('' = can send): reason, who cancelled, then the teacher's request time (empty, invalid, future).
export function group_cancel_problem({
  reason,
  cancel_pick,
  epoch_start_time,
  requested_local,
  now_ms,
  session_type
}) {
  if (!String(reason || '').trim()) return 'reason';
  if (!asks_who_cancelled(session_type)) return '';
  // Who cancelled is required, like the 1-on-1 cancel: a blank pick would leave a teacher cancel unpriced.
  if (!cancel_pick) return 'who';
  const { missing } = teacher_cancel_check({
    status: 'CANCELLED',
    cancelled_by_teacher: needs_teacher_time(cancel_pick, epoch_start_time),
    epoch_start_time,
    requested_local,
    now_ms
  });
  return missing ? 'time' : '';
}

// POST cancel_group_session. No pick sends no flags (apis keeps its default); the time goes in the
// 1-on-1 field, teacher_cancel_requested_at, as a UTC ISO string.
export function group_cancel_payload({
  session_uuid,
  reason,
  is_workshop,
  cancel_pick,
  requested_local,
  session_type
}) {
  const payload = { session_uuid, reason };
  if (is_workshop) payload.is_workshop = 1;
  if (!cancel_pick || !asks_who_cancelled(session_type)) return payload;
  const sent = group_cancel_flags_sent(cancel_pick);
  payload.cancelled_by_student = sent.student;
  payload.cancelled_by_teacher = sent.teacher;
  if (cancel_pick === GROUP_CANCEL_TEACHER && requested_local) {
    payload.teacher_cancel_requested_at = requested_at_to_iso(requested_local, IST);
  }
  return payload;
}
